import React from 'react';
import { PageLoader } from 'src/lib/PageLoader';

export const AsyncConsignmentProcessPage = ({ ...props }): JSX.Element => (
  <PageLoader
    id='src/pages/ConsignmentProcessPage/ConsignmentProcessPage'
    componentImport={async () => (await import('src/pages/ConsignmentProcessPage/ConsignmentProcessPage'))}
    head={() => async () => {
      return {
        title: 'The Consignment Process',
        description: 'Learn about our step-by-step consignment process for firearms and collectibles',
      };
    }}
    {...props}
  />
);